import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/translation.json";
import ar from "./locales/ar/translation.json";
import ku from "./locales/ku/translation.json";

export const RTL_LANGUAGES = ["ar", "ku"];

export const isRtl = (lang) => RTL_LANGUAGES.includes(lang);

const applyDirection = (lang) => {
  const dir = isRtl(lang) ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", lang);
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      ku: { translation: ku },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "ar", "ku"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "cma_language",
    },
  });

i18n.on("languageChanged", applyDirection);
applyDirection(i18n.language);

export default i18n;
